(function tk9CleanInternalAttribution() {
  var defaults = {
    stripParams: [
      "view",
      "_ab",
      "_fd",
      "_sc",
      "pr_prod_strat",
      "pr_rec_pid",
      "pr_ref_pid",
      "pr_seq",
      "el",
      "fbclid",
      "gclid",
      "gbraid",
      "wbraid",
      "ttclid",
      "msclkid",
      "h_ad_id",
      "h_campaign_id",
      "h_adset_id",
      "h_source",
      "h_medium",
      "h_campaign",
      "h_content",
      "h_term",
      "landing_page",
      "ad_id",
      "adset_id",
      "campaign_id"
    ],
    stripParamPatterns: [
      /^utm_/i,
      /^hyros/i
    ],
    cleanPaths: [
      /^\/products(?:\/|$)/,
      /^\/collections(?:\/|$)/,
      /^\/pages(?:\/|$)/,
      /^\/blogs(?:\/|$)/,
      /^\/cart(?:\/|$)/,
      /^\/discount(?:\/|$)/
    ],
    cleanDiscountRedirects: true,
    debugParam: "tk9_attribution_debug",
    maxMutationBatches: 120
  };

  var config = Object.assign({}, defaults, window.TeamK9InternalAttributionCleanerConfig || {});
  var stripParams = new Set(config.stripParams || defaults.stripParams);
  var stripParamPatterns = config.stripParamPatterns || defaults.stripParamPatterns;
  var mutationBatches = 0;
  var rescanTimer = 0;
  var debug = false;

  try {
    debug = new URLSearchParams(window.location.search).get(config.debugParam) === "1";
  } catch (error) {}

  function log(message, data) {
    if (!debug || !window.console) return;
    window.console.info("[tk9-attribution-cleaner] " + message, data || "");
  }

  function isSkippableHref(value) {
    return !value || /^(#|mailto:|tel:|sms:|javascript:)/i.test(value);
  }

  function isCleanablePath(pathname) {
    return (config.cleanPaths || defaults.cleanPaths).some(function (pattern) {
      return pattern.test(pathname);
    });
  }

  function formatUrl(url, rawHref) {
    if (/^\/\//.test(rawHref)) return "//" + url.host + url.pathname + url.search + url.hash;
    if (/^https?:\/\//i.test(rawHref)) return url.toString();
    if (/^\?/.test(rawHref)) return url.search + url.hash;
    return url.pathname + url.search + url.hash;
  }

  function shouldStripParam(param) {
    if (stripParams.has(param)) return true;
    return stripParamPatterns.some(function (pattern) {
      return pattern.test(param);
    });
  }

  function stripInternalAttributionParams(url) {
    var changed = false;

    Array.from(url.searchParams.keys()).forEach(function (param) {
      if (shouldStripParam(param)) {
        url.searchParams.delete(param);
        changed = true;
      }
    });

    return changed;
  }

  function cleanRedirectParam(url) {
    if (!config.cleanDiscountRedirects || !/^\/discount(?:\/|$)/.test(url.pathname)) return false;

    var redirect = url.searchParams.get("redirect");
    if (!redirect) return false;

    var redirectUrl;
    try {
      redirectUrl = new URL(redirect, window.location.origin);
    } catch (error) {
      return false;
    }

    if (redirectUrl.origin !== window.location.origin || !isCleanablePath(redirectUrl.pathname)) return false;

    var changed = stripInternalAttributionParams(redirectUrl);
    if (!changed) return false;

    url.searchParams.set("redirect", redirectUrl.pathname + redirectUrl.search + redirectUrl.hash);
    return true;
  }

  function cleanHref(rawHref) {
    if (isSkippableHref(rawHref)) return rawHref;

    var url;
    try {
      url = new URL(rawHref, window.location.href);
    } catch (error) {
      return rawHref;
    }

    if (url.origin !== window.location.origin || !isCleanablePath(url.pathname)) return rawHref;

    var changed = stripInternalAttributionParams(url);
    changed = cleanRedirectParam(url) || changed;

    return changed ? formatUrl(url, rawHref) : rawHref;
  }

  function installHrefWriteGuard() {
    if (!window.HTMLAnchorElement || window.__tk9InternalAttributionHrefGuard) return;
    window.__tk9InternalAttributionHrefGuard = true;

    var anchorProto = window.HTMLAnchorElement.prototype;
    var originalSetAttribute = anchorProto.setAttribute;
    anchorProto.setAttribute = function (name, value) {
      if (String(name).toLowerCase() === "href") {
        return originalSetAttribute.call(this, name, cleanHref(String(value)));
      }
      return originalSetAttribute.apply(this, arguments);
    };

    try {
      var descriptor = Object.getOwnPropertyDescriptor(anchorProto, "href");
      if (descriptor && descriptor.configurable && descriptor.get && descriptor.set) {
        Object.defineProperty(anchorProto, "href", {
          configurable: descriptor.configurable,
          enumerable: descriptor.enumerable,
          get: descriptor.get,
          set: function (value) {
            descriptor.set.call(this, cleanHref(String(value)));
          }
        });
      }
    } catch (error) {}
  }

  function cleanAnchor(anchor) {
    if (!anchor || anchor.dataset.tk9PreserveQuery === "true") return;

    var rawHref = anchor.getAttribute("href");
    var cleanedHref = cleanHref(rawHref);

    if (cleanedHref && cleanedHref !== rawHref) {
      anchor.setAttribute("href", cleanedHref);
      anchor.dataset.tk9AttributionCleaned = "true";
      log("cleaned internal href", { before: rawHref, after: cleanedHref });
    }
  }

  function cleanAnchors(root) {
    if (!root || !root.querySelectorAll) return;

    if (root.matches && root.matches("a[href]")) cleanAnchor(root);
    root.querySelectorAll("a[href]").forEach(cleanAnchor);
  }

  function scheduleClean(root) {
    window.clearTimeout(rescanTimer);
    window.requestAnimationFrame(function () {
      cleanAnchors(root || document);
    });
    rescanTimer = window.setTimeout(function () {
      cleanAnchors(document);
    }, 250);
  }

  installHrefWriteGuard();
  cleanAnchors(document);

  document.addEventListener("DOMContentLoaded", function () {
    cleanAnchors(document);
  });

  document.addEventListener(
    "click",
    function (event) {
      var anchor = event.target && event.target.closest ? event.target.closest("a[href]") : null;
      cleanAnchor(anchor);
    },
    true
  );

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      mutationBatches += 1;
      if (mutationBatches > config.maxMutationBatches) {
        observer.disconnect();
        return;
      }

      mutations.forEach(function (mutation) {
        if (mutation.type === "attributes" && mutation.attributeName === "href") {
          scheduleClean(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scheduleClean(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["href"],
      childList: true,
      subtree: true
    });
  }
})();
